// extracted by extract-css-chunks-webpack-plugin
module.exports = {"errorCardBody":"ErrorBox-1ccf35ec1186961a"};